module.exports = __webpack_public_path__ + "resources/img/img_netbackup_m.9542dcf37cb0e5d8f3df302084f6e480.png";